import { render, staticRenderFns } from "./importPayrollData.vue?vue&type=template&id=4d094672&scoped=true&"
import script from "./importPayrollData.vue?vue&type=script&lang=js&"
export * from "./importPayrollData.vue?vue&type=script&lang=js&"
import style0 from "./importPayrollData.vue?vue&type=style&index=0&id=4d094672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d094672",
  null
  
)

export default component.exports